import { useQuery } from "react-query";
import { getPreventiveMaintenancePlan } from "../../../../actions/CarrierAgreementMgmt/Security";

export const usePreventiveMaintenancePlan = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetPreventiveMaintenancePlan",
    getPreventiveMaintenancePlan,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
